// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"595":"4c778c8c","875":"4c778c8c"}[chunkId] + ".chunk.css";
};